import { createBrowserRouter } from "react-router-dom";
import Home from "./Components/Home/Home";
import Bookshelf from "./Components/Home/Projects/Bookshelf";
import Brainless from "./Components/Home/Projects/Brainless";
import Carportal from "./Components/Home/Projects/Carportal";
import Main from "./Main";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/carportal',
                element: <Carportal></Carportal>
            },
            {
                path: '/brainless',
                element: <Brainless></Brainless>
            },
            {
                path: '/book',
                element: <Bookshelf></Bookshelf>
            },
        ]

    }
])

export default router